require('./externalTransferFundSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordProcess } = require('utilities/tagging');

// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const ExternalTransferFundDetails = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundDetails/externalTransferFundDetails');
// @ constants
const { BROKER_PG_URL } = require('constants/index');
const { PROC_END } = require('utilities/tagging');

class ExternalTransferFundSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.handleSecondaryButton = this.handleSecondaryButton.bind(this);
    }

    componentDidMount() {
        recordProcess('proc-broker-transpaso-externo-fondo-inversion', PROC_END);
    }

    handleSecondaryButton() {
        this.props.reset();
    }

    render() {
        const mainButton = {
            label: formatText('brokerExternalTransferFundSuccess-finish'),
            url: BROKER_PG_URL,
            modifier: 'secondary'
        };
        const secondaryButton = {
            label: formatText('brokerExternalTransferFundSuccess-newTransferButton')
        };

        return (
            <div>
                <WizardSuccess
                    successMessage={formatText('brokerExternalTransferFundSuccess-message')}
                    mainButton={mainButton}
                    secondaryButton={secondaryButton}
                    onSecondaryButtonClick={this.handleSecondaryButton}
                >
                    <div className="external-transfer-fund-success__details">
                        <FormattedText value="brokerExternalTransferFundSuccess-details" />
                        <div className="clearfix" />
                    </div>
                    <ExternalTransferFundDetails
                        {...this.props}
                        isSuccess={true}
                        modifier="no-bottom-border"
                    />
                </WizardSuccess>
            </div>
        );
    }
}

ExternalTransferFundSuccess.propTypes = {
    immExternalTransferFund: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
    isSuccess: PropTypes.bool,
    reset: PropTypes.func.isRequired
};

module.exports = ExternalTransferFundSuccess;